import { Monitor, Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";

/**
 * Light / Dark / System entries for use inside any DropdownMenuContent (header or sidebar).
 */
export function ThemePreferenceMenuItems(): JSX.Element {
  const { t } = useTranslation();
  const { setTheme, theme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return (
      <DropdownMenuItem disabled className="cursor-default">
        {t("theme.label")}
      </DropdownMenuItem>
    );
  }

  return (
    <>
      <DropdownMenuItem
        onClick={() => setTheme("light")}
        className={cn(
          "cursor-pointer gap-2 transition-colors duration-150",
          theme === "light" && "bg-accent"
        )}
      >
        <Sun className="mr-2 h-4 w-4 shrink-0" aria-hidden />
        {t("theme.light")}
      </DropdownMenuItem>
      <DropdownMenuItem
        onClick={() => setTheme("dark")}
        className={cn(
          "cursor-pointer gap-2 transition-colors duration-150",
          theme === "dark" && "bg-accent"
        )}
      >
        <Moon className="mr-2 h-4 w-4 shrink-0" aria-hidden />
        {t("theme.dark")}
      </DropdownMenuItem>
      <DropdownMenuItem
        onClick={() => setTheme("system")}
        className={cn(
          "cursor-pointer gap-2 transition-colors duration-150",
          theme === "system" && "bg-accent"
        )}
      >
        <Monitor className="mr-2 h-4 w-4 shrink-0" aria-hidden />
        {t("theme.system")}
      </DropdownMenuItem>
    </>
  );
}
